export const PUT_PROFILE_PICTURE = 'PUT_PROFILE_PICTURE';
export const PUT_TITLE = 'PUT_TITLE';
export const PUT_BIOGRAPHY = 'PUT_BIOGRAPHY';
